import { Location, Organization, Practitioner } from "@medplum/fhirtypes";

/**
 * NUCC Provider Taxonomy Code mappings for medical specialties
 * Reference: https://nucc.org/index.php/code-sets-mainmenu-41/provider-taxonomy-mainmenu-40/csv-mainmenu-57
 */
export const PRACTITIONER_SPECIALTY_CODES = {
  "193200000X": "Multi-Specialty",
  "193400000X": "Single Specialty",
  "207K00000X": "Allergy & Immunology",
  "207KA0200X": "Allergy & Immunology",
  "207KI0005X": "Allergy & Immunology",
  "207L00000X": "Anesthesiology",
  "207LA0401X": "Anesthesiology",
  "207LC0200X": "Anesthesiology",
  "207LH0002X": "Anesthesiology",
  "207LP2900X": "Anesthesiology",
  "207LP3000X": "Anesthesiology",
  "207LP4000X": "Anesthesiology",
  "208U00000X": "Clinical Pharmacology",
  "208C00000X": "Colon & Rectal Surgery",
  "207N00000X": "Dermatology",
  "207NI0002X": "Dermatology",
  "207ND0900X": "Dermatology",
  "207ND0101X": "Dermatology",
  "207NP0225X": "Dermatology",
  "207NS0135X": "Dermatology",
  "204R00000X": "Electrodiagnostic Medicine",
  "207P00000X": "Emergency Medicine",
  "207PE0004X": "Emergency Medicine",
  "207PH0002X": "Emergency Medicine",
  "207PT0002X": "Emergency Medicine",
  "207PP0204X": "Emergency Medicine",
  "207PS0010X": "Emergency Medicine",
  "207PE0005X": "Emergency Medicine",
  "207Q00000X": "Family Medicine",
  "207QA0401X": "Family Medicine",
  "207QA0000X": "Family Medicine",
  "207QA0505X": "Family Medicine",
  "207QG0300X": "Family Medicine",
  "207QH0002X": "Family Medicine",
  "207QB0002X": "Family Medicine",
  "207QP0002X": "Family Medicine",
  "207QS1201X": "Family Medicine",
  "207QS0010X": "Family Medicine",
  "208D00000X": "General Practice",
  "208M00000X": "Hospitalist",
  "202C00000X": "Independent Medical Examiner",
  "202D00000X": "Integrative Medicine",
  "207R00000X": "Internal Medicine",
  "207RA0401X": "Internal Medicine",
  "207RA0000X": "Internal Medicine",
  "207RA0002X": "Internal Medicine",
  "207RA0001X": "Internal Medicine",
  "207RA0201X": "Internal Medicine",
  "207RC0000X": "Internal Medicine",
  "207RI0001X": "Internal Medicine",
  "207RC0001X": "Internal Medicine",
  "207RC0200X": "Internal Medicine",
  "207RE0101X": "Internal Medicine",
  "207RG0100X": "Internal Medicine",
  "207RG0300X": "Internal Medicine",
  "207RH0000X": "Internal Medicine",
  "207RH0003X": "Internal Medicine",
  "207RI0008X": "Internal Medicine",
  "207RH0002X": "Internal Medicine",
  "207RH0005X": "Internal Medicine",
  "207RI0200X": "Internal Medicine",
  "207RI0011X": "Internal Medicine",
  "207RM1200X": "Internal Medicine",
  "207RX0202X": "Internal Medicine",
  "207RN0300X": "Internal Medicine",
  "207RB0002X": "Internal Medicine",
  "207RP1002X": "Internal Medicine",
  "207RP1001X": "Internal Medicine",
  "207RR0500X": "Internal Medicine",
  "207RS0012X": "Internal Medicine",
  "207RS0010X": "Internal Medicine",
  "207RT0003X": "Internal Medicine",
  "209800000X": "Legal Medicine",
  "207SG0202X": "Medical Genetics",
  "207SC0300X": "Medical Genetics",
  "207SG0201X": "Medical Genetics",
  "207SG0203X": "Medical Genetics",
  "207SG0207X": "Medical Genetics",
  "207SM0001X": "Medical Genetics",
  "207SG0205X": "Medical Genetics",
  "207T00000X": "Neurological Surgery",
  "204D00000X": "Neuromusculoskeletal Medicine & OMM",
  "204C00000X": "Neuromusculoskeletal Medicine, Sports Medicine",
  "207U00000X": "Nuclear Medicine",
  "207UN0903X": "Nuclear Medicine",
  "207UN0901X": "Nuclear Medicine",
  "207UN0902X": "Nuclear Medicine",
  "207V00000X": "Obstetrics & Gynecology",
  "207VC0300X": "Obstetrics & Gynecology",
  "207VC0200X": "Obstetrics & Gynecology",
  "207VF0040X": "Obstetrics & Gynecology",
  "207VX0201X": "Obstetrics & Gynecology",
  "207VG0400X": "Obstetrics & Gynecology",
  "207VH0002X": "Obstetrics & Gynecology",
  "207VM0101X": "Obstetrics & Gynecology",
  "207VB0002X": "Obstetrics & Gynecology",
  "207VX0000X": "Obstetrics & Gynecology",
  "207VE0102X": "Obstetrics & Gynecology",
  "207W00000X": "Ophthalmology",
  "207WX0120X": "Ophthalmology",
  "207WX0009X": "Ophthalmology",
  "207WX0109X": "Ophthalmology",
  "207WX0200X": "Ophthalmology",
  "207WX0110X": "Ophthalmology",
  "207WX0107X": "Ophthalmology",
  "207WX0108X": "Ophthalmology",
  "204E00000X": "Oral & Maxillofacial Surgery",
  "207X00000X": "Orthopaedic Surgery",
  "207XS0114X": "Orthopaedic Surgery",
  "207XX0004X": "Orthopaedic Surgery",
  "207XS0106X": "Orthopaedic Surgery",
  "207XS0117X": "Orthopaedic Surgery",
  "207XX0801X": "Orthopaedic Surgery",
  "207XP3100X": "Orthopaedic Surgery",
  "207XX0005X": "Orthopaedic Surgery",
  "207Y00000X": "Otolaryngology",
  "207YS0123X": "Otolaryngology",
  "207YX0602X": "Otolaryngology",
  "207YX0905X": "Otolaryngology",
  "207YX0901X": "Otolaryngology",
  "207YP0228X": "Otolaryngology",
  "207YX0007X": "Otolaryngology",
  "207YS0012X": "Otolaryngology",
  "208VP0014X": "Pain Medicine",
  "208VP0000X": "Pain Medicine",
  "207ZP0101X": "Pathology",
  "207ZP0102X": "Pathology",
  "207ZB0001X": "Pathology",
  "207ZP0104X": "Pathology",
  "207ZC0008X": "Pathology",
  "207ZC0006X": "Pathology",
  "207ZP0105X": "Pathology",
  "207ZC0500X": "Pathology",
  "207ZD0900X": "Pathology",
  "207ZF0201X": "Pathology",
  "207ZH0000X": "Pathology",
  "207ZI0100X": "Pathology",
  "207ZM0300X": "Pathology",
  "207ZP0007X": "Pathology",
  "207ZN0500X": "Pathology",
  "207ZP0213X": "Pathology",
  "208000000X": "Pediatrics",
  "2080A0000X": "Pediatrics",
  "2080C0008X": "Pediatrics",
  "2080I0007X": "Pediatrics",
  "2080P0006X": "Pediatrics",
  "2080H0002X": "Pediatrics",
  "2080T0002X": "Pediatrics",
  "2080N0001X": "Pediatrics",
  "2080P0008X": "Pediatrics",
  "2080B0002X": "Pediatrics",
  "2080P0201X": "Pediatrics",
  "2080P0202X": "Pediatrics",
  "2080P0203X": "Pediatrics",
  "2080P0204X": "Pediatrics",
  "2080P0205X": "Pediatrics",
  "2080P0206X": "Pediatrics",
  "2080P0207X": "Pediatrics",
  "2080P0208X": "Pediatrics",
  "2080P0210X": "Pediatrics",
  "2080P0214X": "Pediatrics",
  "2080P0216X": "Pediatrics",
  "2080T0004X": "Pediatrics",
  "2080P1004X": "Pediatrics",
  "2080S0012X": "Pediatrics",
  "2080S0010X": "Pediatrics",
  "202K00000X": "Phlebology",
  "208100000X": "Physical Medicine & Rehabilitation",
  "2081P0301X": "Physical Medicine & Rehabilitation",
  "2081H0002X": "Physical Medicine & Rehabilitation",
  "2081N0008X": "Physical Medicine & Rehabilitation",
  "2081P2900X": "Physical Medicine & Rehabilitation",
  "2081P0010X": "Physical Medicine & Rehabilitation",
  "2081P0004X": "Physical Medicine & Rehabilitation",
  "2081S0010X": "Physical Medicine & Rehabilitation",
  "208200000X": "Plastic Surgery",
  "2082S0099X": "Plastic Surgery",
  "2082S0105X": "Plastic Surgery",
  "2083A0300X": "Preventive Medicine",
  "2083A0100X": "Preventive Medicine",
  "2083C0008X": "Preventive Medicine",
  "2083T0002X": "Preventive Medicine",
  "2083B0002X": "Preventive Medicine",
  "2083X0100X": "Preventive Medicine",
  "2083P0500X": "Preventive Medicine",
  "2083P0901X": "Preventive Medicine",
  "2083S0010X": "Preventive Medicine",
  "2083P0011X": "Preventive Medicine",
  "2084A0401X": "Psychiatry & Neurology",
  "2084P0802X": "Psychiatry & Neurology",
  "2084B0040X": "Psychiatry & Neurology",
  "2084P0301X": "Psychiatry & Neurology",
  "2084P0804X": "Psychiatry & Neurology",
  "2084N0600X": "Psychiatry & Neurology",
  "2084D0003X": "Psychiatry & Neurology",
  "2084E0001X": "Psychiatry & Neurology",
  "2084F0202X": "Psychiatry & Neurology",
  "2084P0805X": "Psychiatry & Neurology",
  "2084H0002X": "Psychiatry & Neurology",
  "2084A2900X": "Psychiatry & Neurology",
  "2084P0005X": "Psychiatry & Neurology",
  "2084N0400X": "Psychiatry & Neurology",
  "2084N0402X": "Psychiatry & Neurology",
  "2084N0008X": "Psychiatry & Neurology",
  "2084B0002X": "Psychiatry & Neurology",
  "2084P2900X": "Psychiatry & Neurology",
  "2084P0800X": "Psychiatry & Neurology",
  "2084P0015X": "Psychiatry & Neurology",
  "2084S0012X": "Psychiatry & Neurology",
  "2084S0010X": "Psychiatry & Neurology",
  "2084V0102X": "Psychiatry & Neurology",
  "2085B0100X": "Radiology",
  "2085D0003X": "Radiology",
  "2085R0202X": "Radiology",
  "2085U0001X": "Radiology",
  "2085H0002X": "Radiology",
  "2085N0700X": "Radiology",
  "2085N0904X": "Radiology",
  "2085P0229X": "Radiology",
  "2085R0001X": "Radiology",
  "2085R0205X": "Radiology",
  "2085R0203X": "Radiology",
  "2085R0204X": "Radiology",
  "208600000X": "Surgery",
  "2086H0002X": "Surgery",
  "2086S0120X": "Surgery",
  "2086P0122X": "Surgery",
  "2086S0122X": "Surgery",
  "2086S0105X": "Surgery",
  "2086S0102X": "Surgery",
  "2086X0206X": "Surgery",
  "2086S0127X": "Surgery",
  "2086S0129X": "Surgery",
  "208G00000X": "Thoracic Surgery (Cardiothoracic Vascular Surgery)",
  "204F00000X": "Transplant Surgery",
  "208800000X": "Urology",
  "2088F0040X": "Urology",
  "2088P0231X": "Urology",
  "106E00000X": "Assistant Behavior Analyst",
  "106S00000X": "Behavior Technician",
  "103K00000X": "Behavior Analyst",
  "103G00000X": "Clinical Neuropsychologist",
  "103GC0700X": "Clinical Neuropsychologist",
  "101Y00000X": "Counselor",
  "101YA0400X": "Counselor",
  "101YM0800X": "Counselor",
  "101YP1600X": "Counselor",
  "101YP2500X": "Counselor",
  "101YS0200X": "Counselor",
  "101200000X": "Drama Therapist",
  "106H00000X": "Marriage & Family Therapist",
  "102X00000X": "Poetry Therapist",
  "102L00000X": "Psychoanalyst",
  "103T00000X": "Psychologist",
  "103TA0400X": "Psychologist",
  "103TA0700X": "Psychologist",
  "103TC0700X": "Psychologist",
  "103TC2200X": "Psychologist",
  "103TB0200X": "Psychologist",
  "103TC1900X": "Psychologist",
  "103TE1000X": "Psychologist",
  "103TE1100X": "Psychologist",
  "103TF0000X": "Psychologist",
  "103TF0200X": "Psychologist",
  "103TP2701X": "Psychologist",
  "103TH0004X": "Psychologist",
  "103TH0100X": "Psychologist",
  "103TM1700X": "Psychologist",
  "103TM1800X": "Psychologist",
  "103TP0016X": "Psychologist",
  "103TP0814X": "Psychologist",
  "103TP2700X": "Psychologist",
  "103TR0400X": "Psychologist",
  "103TS0200X": "Psychologist",
  "103TW0100X": "Psychologist",
  "104100000X": "Social Worker",
  "1041C0700X": "Social Worker",
  "1041S0200X": "Social Worker",
  "111N00000X": "Chiropractor",
  "111NI0013X": "Chiropractor",
  "111NI0900X": "Chiropractor",
  "111NN0400X": "Chiropractor",
  "111NN1001X": "Chiropractor",
  "111NX0100X": "Chiropractor",
  "111NX0800X": "Chiropractor",
  "111NP0017X": "Chiropractor",
  "111NR0200X": "Chiropractor",
  "111NR0400X": "Chiropractor",
  "111NS0005X": "Chiropractor",
  "111NT0100X": "Chiropractor",
  "125K00000X": "Advanced Practice Dental Therapist",
  "126800000X": "Dental Assistant",
  "124Q00000X": "Dental Hygienist",
  "126900000X": "Dental Laboratory Technician",
  "125J00000X": "Dental Therapist",
  "122300000X": "Dentist",
  "1223D0004X": "Dentist",
  "1223D0001X": "Dentist",
  "1223E0200X": "Dentist",
  "1223G0001X": "Dentist",
  "1223P0106X": "Dentist",
  "1223X0008X": "Dentist",
  "1223S0112X": "Dentist",
  "125Q00000X": "Dentist",
  "1223X2210X": "Dentist",
  "1223X0400X": "Dentist",
  "1223P0221X": "Dentist",
  "1223P0300X": "Dentist",
  "1223P0700X": "Dentist",
  "122400000X": "Denturist",
  "132700000X": "Dietary Manager",
  "136A00000X": "Dietetic Technician, Registered",
  "133V00000X": "Dietitian, Registered",
  "133VN1101X": "Dietitian, Registered",
  "133VN1006X": "Dietitian, Registered",
  "133VN1201X": "Dietitian, Registered",
  "133VN1301X": "Dietitian, Registered",
  "133VN1004X": "Dietitian, Registered",
  "133VN1401X": "Dietitian, Registered",
  "133VN1005X": "Dietitian, Registered",
  "133VN1501X": "Dietitian, Registered",
  "133N00000X": "Nutritionist",
  "133NN1002X": "Nutritionist",
  "146N00000X": "Emergency Medical Technician, Basic",
  "146M00000X": "Emergency Medical Technician, Intermediate",
  "146L00000X": "Emergency Medical Technician, Paramedic",
  "146D00000X": "Personal Emergency Response Attendant",
  "152W00000X": "Optometrist",
  "152WC0802X": "Optometrist",
  "152WL0500X": "Optometrist",
  "152WX0102X": "Optometrist",
  "152WP0200X": "Optometrist",
  "152WS0006X": "Optometrist",
  "152WV0400X": "Optometrist",
  "156F00000X": "Technician/Technologist",
  "156FC0800X": "Technician/Technologist",
  "156FC0801X": "Technician/Technologist",
  "156FX1700X": "Technician/Technologist",
  "156FX1100X": "Technician/Technologist",
  "156FX1101X": "Technician/Technologist",
  "156FX1800X": "Technician/Technologist",
  "156FX1201X": "Technician/Technologist",
  "156FX1202X": "Technician/Technologist",
  "156FX1900X": "Technician/Technologist",
  "164W00000X": "Licensed Practical Nurse",
  "167G00000X": "Licensed Psychiatric Technician",
  "164X00000X": "Licensed Vocational Nurse",
  "163W00000X": "Registered Nurse",
  "163WA0400X": "Registered Nurse",
  "163WA2000X": "Registered Nurse",
  "163WP2201X": "Registered Nurse",
  "163WC3500X": "Registered Nurse",
  "163WC0400X": "Registered Nurse",
  "163WC1400X": "Registered Nurse",
  "163WC1500X": "Registered Nurse",
  "163WC2100X": "Registered Nurse",
  "163WC1600X": "Registered Nurse",
  "163WC0200X": "Registered Nurse",
  "163WD0400X": "Registered Nurse",
  "163WD1100X": "Registered Nurse",
  "163WE0003X": "Registered Nurse",
  "163WE0900X": "Registered Nurse",
  "163WF0300X": "Registered Nurse",
  "163WG0100X": "Registered Nurse",
  "163WG0000X": "Registered Nurse",
  "163WG0600X": "Registered Nurse",
  "163WH0500X": "Registered Nurse",
  "163WH0200X": "Registered Nurse",
  "163WH1000X": "Registered Nurse",
  "163WI0600X": "Registered Nurse",
  "163WI0500X": "Registered Nurse",
  "163WL0100X": "Registered Nurse",
  "163WM0102X": "Registered Nurse",
  "163WM0705X": "Registered Nurse",
  "163WN0002X": "Registered Nurse",
  "163WN0003X": "Registered Nurse",
  "163WN0300X": "Registered Nurse",
  "163WN0800X": "Registered Nurse",
  "163WM1400X": "Registered Nurse",
  "163WN1003X": "Registered Nurse",
  "163WX0002X": "Registered Nurse",
  "163WX0003X": "Registered Nurse",
  "163WX0106X": "Registered Nurse",
  "163WX0200X": "Registered Nurse",
  "163WX1100X": "Registered Nurse",
  "163WX0800X": "Registered Nurse",
  "163WX1500X": "Registered Nurse",
  "163WX0601X": "Registered Nurse",
  "163WP0000X": "Registered Nurse",
  "163WP0218X": "Registered Nurse",
  "163WP0200X": "Registered Nurse",
  "163WP1700X": "Registered Nurse",
  "163WS0121X": "Registered Nurse",
  "163WP0808X": "Registered Nurse",
  "163WP0809X": "Registered Nurse",
  "163WP0807X": "Registered Nurse",
  "163WR0006X": "Registered Nurse",
  "163WR0400X": "Registered Nurse",
  "163WR1000X": "Registered Nurse",
  "163WS0200X": "Registered Nurse",
  "163WU0100X": "Registered Nurse",
  "163WW0101X": "Registered Nurse",
  "163WW0000X": "Registered Nurse",
  "372600000X": "Adult Companion",
  "372500000X": "Chore Provider",
  "373H00000X": "Day Training/Habilitation Specialist",
  "374J00000X": "Doula",
  "374U00000X": "Home Health Aide",
  "376J00000X": "Homemaker",
  "376K00000X": "Nurse's Aide",
  "376G00000X": "Nursing Home Administrator",
  "374T00000X": "Religious Nonmedical Nursing Personnel",
  "374K00000X": "Religious Nonmedical Practitioner",
  "374700000X": "Technician",
  "3747A0650X": "Technician",
  "3747P1801X": "Technician",
  "171100000X": "Acupuncturist",
  "171M00000X": "Case Manager/Care Coordinator",
  "174V00000X": "Clinical Ethicist",
  "172V00000X": "Community Health Worker",
  "171W00000X": "Contractor",
  "171WH0202X": "Contractor",
  "171WV0202X": "Contractor",
  "172A00000X": "Driver",
  "176P00000X": "Funeral Director",
  "170300000X": "Genetic Counselor, MS",
  "171400000X": "Health & Wellness Coach",
  "174H00000X": "Health Educator",
  "175L00000X": "Homeopath",
  "171R00000X": "Interpreter",
  "174N00000X": "Lactation Consultant, Non-RN",
  "175M00000X": "Midwife, Lay",
  "173000000X": "Legal Medicine",
  "172M00000X": "Mechanotherapist",
  "176B00000X": "Midwife",
  "171000000X": "Military Health Care Provider",
  "1710I1002X": "Military Health Care Provider",
  "1710I1003X": "Military Health Care Provider",
  "172P00000X": "Naprapath",
  "175F00000X": "Naturopath",
  "175T00000X": "Peer Specialist",
  "170100000X": "Medical Genetics, Ph.D. Medical Genetics",
  "405300000X": "Prevention Professional",
  "173C00000X": "Reflexologist",
  "173F00000X": "Sleep Specialist, PhD",
  "174400000X": "Specialist",
  "1744G0900X": "Specialist",
  "1744P3200X": "Specialist",
  "1744R1103X": "Specialist",
  "1744R1102X": "Specialist",
  "174M00000X": "Veterinarian",
  "174MM1900X": "Veterinarian",
  "183500000X": "Pharmacist",
  "1835P2201X": "Pharmacist",
  "1835C0206X": "Pharmacist",
  "1835C0207X": "Pharmacist",
  "1835C0205X": "Pharmacist",
  "1835E0208X": "Pharmacist",
  "1835G0000X": "Pharmacist",
  "1835G0303X": "Pharmacist",
  "1835I0206X": "Pharmacist",
  "1835N0905X": "Pharmacist",
  "1835N1003X": "Pharmacist",
  "1835X0200X": "Pharmacist",
  "1835P0200X": "Pharmacist",
  "1835P0018X": "Pharmacist",
  "1835P1200X": "Pharmacist",
  "1835P1300X": "Pharmacist",
  "1835S0206X": "Pharmacist",
  "183700000X": "Pharmacy Technician",
  "367A00000X": "Advanced Practice Midwife",
  "367H00000X": "Anesthesiologist Assistant",
  "364S00000X": "Clinical Nurse Specialist",
  "364SA2100X": "Clinical Nurse Specialist",
  "364SA2200X": "Clinical Nurse Specialist",
  "364SC2300X": "Clinical Nurse Specialist",
  "364SC1501X": "Clinical Nurse Specialist",
  "364SC0200X": "Clinical Nurse Specialist",
  "364SE0003X": "Clinical Nurse Specialist",
  "364SE1400X": "Clinical Nurse Specialist",
  "364SF0001X": "Clinical Nurse Specialist",
  "364SG0600X": "Clinical Nurse Specialist",
  "364SH1100X": "Clinical Nurse Specialist",
  "364SH0200X": "Clinical Nurse Specialist",
  "364SI0800X": "Clinical Nurse Specialist",
  "364SL0600X": "Clinical Nurse Specialist",
  "364SM0705X": "Clinical Nurse Specialist",
  "364SN0000X": "Clinical Nurse Specialist",
  "364SN0800X": "Clinical Nurse Specialist",
  "364SX0106X": "Clinical Nurse Specialist",
  "364SX0200X": "Clinical Nurse Specialist",
  "364SX0204X": "Clinical Nurse Specialist",
  "364SP0200X": "Clinical Nurse Specialist",
  "364SP1700X": "Clinical Nurse Specialist",
  "364SP2800X": "Clinical Nurse Specialist",
  "364SP0808X": "Clinical Nurse Specialist",
  "364SP0809X": "Clinical Nurse Specialist",
  "364SP0807X": "Clinical Nurse Specialist",
  "364SP0810X": "Clinical Nurse Specialist",
  "364SP0811X": "Clinical Nurse Specialist",
  "364SP0812X": "Clinical Nurse Specialist",
  "364SP0813X": "Clinical Nurse Specialist",
  "364SR0400X": "Clinical Nurse Specialist",
  "364SS0200X": "Clinical Nurse Specialist",
  "364ST0500X": "Clinical Nurse Specialist",
  "364SW0102X": "Clinical Nurse Specialist",
  "367500000X": "Nurse Anesthetist, Certified Registered",
  "363L00000X": "Nurse Practitioner",
  "363LA2100X": "Nurse Practitioner",
  "363LA2200X": "Nurse Practitioner",
  "363LC1500X": "Nurse Practitioner",
  "363LC0200X": "Nurse Practitioner",
  "363LF0000X": "Nurse Practitioner",
  "363LG0600X": "Nurse Practitioner",
  "363LN0000X": "Nurse Practitioner",
  "363LN0005X": "Nurse Practitioner",
  "363LX0001X": "Nurse Practitioner",
  "363LX0106X": "Nurse Practitioner",
  "363LP0200X": "Nurse Practitioner",
  "363LP0222X": "Nurse Practitioner",
  "363LP1700X": "Nurse Practitioner",
  "363LP2300X": "Nurse Practitioner",
  "363LP0808X": "Nurse Practitioner",
  "363LS0200X": "Nurse Practitioner",
  "363LW0102X": "Nurse Practitioner",
  "363A00000X": "Physician Assistant",
  "363AM0700X": "Physician Assistant",
  "363AS0400X": "Physician Assistant",
  "211D00000X": "Assistant, Podiatric",
  "213E00000X": "Podiatrist",
  "213ES0103X": "Podiatrist",
  "213ES0131X": "Podiatrist",
  "213EG0000X": "Podiatrist",
  "213EP1101X": "Podiatrist",
  "213EP0504X": "Podiatrist",
  "213ER0200X": "Podiatrist",
  "213ES0000X": "Podiatrist",
  "229N00000X": "Anaplastologist",
  "221700000X": "Art Therapist",
  "224Y00000X": "Clinical Exercise Physiologist",
  "225600000X": "Dance Therapist",
  "222Q00000X": "Developmental Therapist",
  "226300000X": "Kinesiotherapist",
  "225700000X": "Massage Therapist",
  "224900000X": "Mastectomy Fitter",
  "225A00000X": "Music Therapist",
  "225X00000X": "Occupational Therapist",
  "225XR0403X": "Occupational Therapist",
  "225XE0001X": "Occupational Therapist",
  "225XE1200X": "Occupational Therapist",
  "225XF0002X": "Occupational Therapist",
  "225XG0600X": "Occupational Therapist",
  "225XH1200X": "Occupational Therapist",
  "225XH1300X": "Occupational Therapist",
  "225XL0004X": "Occupational Therapist",
  "225XM0800X": "Occupational Therapist",
  "225XN1300X": "Occupational Therapist",
  "225XP0200X": "Occupational Therapist",
  "225XP0019X": "Occupational Therapist",
  "224Z00000X": "Occupational Therapy Assistant",
  "224ZR0403X": "Occupational Therapy Assistant",
  "224ZE0001X": "Occupational Therapy Assistant",
  "224ZF0002X": "Occupational Therapy Assistant",
  "224ZL0004X": "Occupational Therapy Assistant",
  "225000000X": "Orthotic Fitter",
  "222Z00000X": "Orthotist",
  "224L00000X": "Pedorthist",
  "225100000X": "Physical Therapist",
  "2251C2600X": "Physical Therapist",
  "2251E1300X": "Physical Therapist",
  "2251E1200X": "Physical Therapist",
  "2251G0304X": "Physical Therapist",
  "2251H1200X": "Physical Therapist",
  "2251H1300X": "Physical Therapist",
  "2251N0400X": "Physical Therapist",
  "2251X0800X": "Physical Therapist",
  "2251P0200X": "Physical Therapist",
  "2251S0007X": "Physical Therapist",
  "225200000X": "Physical Therapy Assistant",
  "224P00000X": "Prosthetist",
  "225B00000X": "Pulmonary Function Technologist",
  "225800000X": "Recreation Therapist",
  "226000000X": "Recreational Therapist Assistant",
  "225C00000X": "Rehabilitation Counselor",
  "225CA2400X": "Rehabilitation Counselor",
  "225CA2500X": "Rehabilitation Counselor",
  "225CX0006X": "Rehabilitation Counselor",
  "225400000X": "Rehabilitation Practitioner",
  "227800000X": "Respiratory Therapist, Certified",
  "2278C0205X": "Respiratory Therapist, Certified",
  "2278E1000X": "Respiratory Therapist, Certified",
  "2278E0002X": "Respiratory Therapist, Certified",
  "2278G1100X": "Respiratory Therapist, Certified",
  "2278G0305X": "Respiratory Therapist, Certified",
  "2278H0200X": "Respiratory Therapist, Certified",
  "2278P3900X": "Respiratory Therapist, Certified",
  "2278P3800X": "Respiratory Therapist, Certified",
  "2278P4000X": "Respiratory Therapist, Certified",
  "2278P1004X": "Respiratory Therapist, Certified",
  "2278P1006X": "Respiratory Therapist, Certified",
  "2278P1005X": "Respiratory Therapist, Certified",
  "2278S1500X": "Respiratory Therapist, Certified",
  "227900000X": "Respiratory Therapist, Registered",
  "2279C0205X": "Respiratory Therapist, Registered",
  "2279E1000X": "Respiratory Therapist, Registered",
  "2279E0002X": "Respiratory Therapist, Registered",
  "2279G1100X": "Respiratory Therapist, Registered",
  "2279G0305X": "Respiratory Therapist, Registered",
  "2279H0200X": "Respiratory Therapist, Registered",
  "2279P3900X": "Respiratory Therapist, Registered",
  "2279P3800X": "Respiratory Therapist, Registered",
  "2279P4000X": "Respiratory Therapist, Registered",
  "2279P1004X": "Respiratory Therapist, Registered",
  "2279P1006X": "Respiratory Therapist, Registered",
  "2279P1005X": "Respiratory Therapist, Registered",
  "2279S1500X": "Respiratory Therapist, Registered",
  "225500000X": "Specialist/Technologist",
  "2255A2300X": "Specialist/Technologist",
  "2255R0406X": "Specialist/Technologist",
  "231H00000X": "Audiologist",
  "231HA2400X": "Audiologist",
  "231HA2500X": "Audiologist",
  "237600000X": "Audiologist-Hearing Aid Fitter",
  "237700000X": "Hearing Instrument Specialist",
  "235500000X": "Specialist/Technologist",
  "2355A2700X": "Specialist/Technologist",
  "2355S0801X": "Specialist/Technologist",
  "235Z00000X": "Speech-Language Pathologist",
  "390200000X": "Student in an Organized Health Care Education/Training Program",
  "242T00000X": "Perfusionist",
  "247100000X": "Radiologic Technologist",
  "2471B0102X": "Radiologic Technologist",
  "2471C1106X": "Radiologic Technologist",
  "2471C1101X": "Radiologic Technologist",
  "2471C3401X": "Radiologic Technologist",
  "2471M1202X": "Radiologic Technologist",
  "2471M2300X": "Radiologic Technologist",
  "2471N0900X": "Radiologic Technologist",
  "2471Q0001X": "Radiologic Technologist",
  "2471R0002X": "Radiologic Technologist",
  "2471C3402X": "Radiologic Technologist",
  "2471S1302X": "Radiologic Technologist",
  "2471V0105X": "Radiologic Technologist",
  "2471V0106X": "Radiologic Technologist",
  "243U00000X": "Radiology Practitioner Assistant",
  "246X00000X": "Specialist/Technologist Cardiovascular",
  "246XC2901X": "Specialist/Technologist Cardiovascular",
  "246XS1301X": "Specialist/Technologist Cardiovascular",
  "246XC2903X": "Specialist/Technologist Cardiovascular",
  "246Y00000X": "Specialist/Technologist, Health Information",
  "246YC3301X": "Specialist/Technologist, Health Information",
  "246YC3302X": "Specialist/Technologist, Health Information",
  "246YR1600X": "Specialist/Technologist, Health Information",
  "246Z00000X": "Specialist/Technologist, Other",
  "246ZA2600X": "Specialist/Technologist, Other",
  "246ZB0500X": "Specialist/Technologist, Other",
  "246ZB0301X": "Specialist/Technologist, Other",
  "246ZB0302X": "Specialist/Technologist, Other",
  "246ZB0600X": "Specialist/Technologist, Other",
  "246ZE0500X": "Specialist/Technologist, Other",
  "246ZE0600X": "Specialist/Technologist, Other",
  "246ZG1000X": "Specialist/Technologist, Other",
  "246ZG0701X": "Specialist/Technologist, Other",
  "246ZI1000X": "Specialist/Technologist, Other",
  "246ZN0300X": "Specialist/Technologist, Other",
  "246ZX2200X": "Specialist/Technologist, Other",
  "246ZC0007X": "Specialist/Technologist, Other",
  "246ZS0410X": "Specialist/Technologist, Other",
  "246Q00000X": "Specialist/Technologist, Pathology",
  "246QB0000X": "Specialist/Technologist, Pathology",
  "246QC1000X": "Specialist/Technologist, Pathology",
  "246QC2700X": "Specialist/Technologist, Pathology",
  "246QH0401X": "Specialist/Technologist, Pathology",
  "246QH0000X": "Specialist/Technologist, Pathology",
  "246QH0600X": "Specialist/Technologist, Pathology",
  "246QI0000X": "Specialist/Technologist, Pathology",
  "246QL0900X": "Specialist/Technologist, Pathology",
  "246QL0901X": "Specialist/Technologist, Pathology",
  "246QM0706X": "Specialist/Technologist, Pathology",
  "246QM0900X": "Specialist/Technologist, Pathology",
  "246W00000X": "Technician, Cardiology",
  "247000000X": "Technician, Health Information",
  "2470A2800X": "Technician, Health Information",
  "247200000X": "Technician, Other",
  "2472B0301X": "Technician, Other",
  "2472D0500X": "Technician, Other",
  "2472E0500X": "Technician, Other",
  "2472R0900X": "Technician, Other",
  "2472V0600X": "Technician, Other",
  "246R00000X": "Technician, Pathology",
  "247ZC0005X": "Technician, Pathology",
  "246RH0600X": "Technician, Pathology",
  "246RM2200X": "Technician, Pathology",
  "246RP1900X": "Technician, Pathology",
  "251B00000X": "Case Management",
  "251S00000X": "Community/Behavioral Health",
  "251C00000X": "Day Training, Developmentally Disabled Services",
  "252Y00000X": "Early Intervention Provider Agency",
  "253J00000X": "Foster Care Agency",
  "251E00000X": "Home Health",
  "251F00000X": "Home Infusion",
  "251G00000X": "Hospice Care, Community Based",
  "253Z00000X": "In Home Supportive Care",
  "251300000X": "Local Education Agency (LEA)",
  "251J00000X": "Nursing Care",
  "251T00000X": "Program of All-Inclusive Care for the Elderly (PACE) Provider Organization",
  "251K00000X": "Public Health or Welfare",
  "251X00000X": "Supports Brokerage",
  "251V00000X": "Voluntary or Charitable",
  "261Q00000X": "Clinic/Center",
  "261QM0855X": "Clinic/Center",
  "261QA0600X": "Clinic/Center",
  "261QM0850X": "Clinic/Center",
  "261QA0005X": "Clinic/Center",
  "261QA0006X": "Clinic/Center",
  "261QA1903X": "Clinic/Center",
  "261QA0900X": "Clinic/Center",
  "261QA3000X": "Clinic/Center",
  "261QB0400X": "Clinic/Center",
  "261QC1500X": "Clinic/Center",
  "261QC1800X": "Clinic/Center",
  "261QC0050X": "Clinic/Center",
  "261QD0000X": "Clinic/Center",
  "261QD1600X": "Clinic/Center",
  "261QE0002X": "Clinic/Center",
  "261QE0700X": "Clinic/Center",
  "261QE0800X": "Clinic/Center",
  "261QF0050X": "Clinic/Center",
  "261QF0400X": "Clinic/Center",
  "261QG0250X": "Clinic/Center",
  "261QH0100X": "Clinic/Center",
  "261QH0700X": "Clinic/Center",
  "261QI0500X": "Clinic/Center",
  "261QL0400X": "Clinic/Center",
  "261QM1200X": "Clinic/Center",
  "261QM2500X": "Clinic/Center",
  "261QM3000X": "Clinic/Center",
  "261QM0801X": "Clinic/Center",
  "261QM2800X": "Clinic/Center",
  "261QM1000X": "Clinic/Center",
  "261QM1103X": "Clinic/Center",
  "261QM1101X": "Clinic/Center",
  "261QM1102X": "Clinic/Center",
  "261QM1100X": "Clinic/Center",
  "261QM1300X": "Clinic/Center",
  "261QX0100X": "Clinic/Center",
  "261QX0200X": "Clinic/Center",
  "261QX0203X": "Clinic/Center",
  "261QS0132X": "Clinic/Center",
  "261QS0112X": "Clinic/Center",
  "261QP3300X": "Clinic/Center",
  "261QP2000X": "Clinic/Center",
  "261QP1100X": "Clinic/Center",
  "261QP2300X": "Clinic/Center",
  "261QP2400X": "Clinic/Center",
  "261QP0904X": "Clinic/Center",
  "261QP0905X": "Clinic/Center",
  "261QR0200X": "Clinic/Center",
  "261QR0206X": "Clinic/Center",
  "261QR0208X": "Clinic/Center",
  "261QR0207X": "Clinic/Center",
  "261QR0800X": "Clinic/Center",
  "261QR0400X": "Clinic/Center",
  "261QR0404X": "Clinic/Center",
  "261QR0401X": "Clinic/Center",
  "261QR0405X": "Clinic/Center",
  "261QR1100X": "Clinic/Center",
  "261QR1300X": "Clinic/Center",
  "261QS1200X": "Clinic/Center",
  "261QS1000X": "Clinic/Center",
  "261QU0200X": "Clinic/Center",
  "261QV0200X": "Clinic/Center",
  "273100000X": "Epilepsy Unit",
  "275N00000X": "Medicare Defined Swing Bed Unit",
  "273R00000X": "Psychiatric Unit",
  "273Y00000X": "Rehabilitation Unit",
  "276400000X": "Rehabilitation, Substance Use Disorder Unit",
  "287300000X": "Christian Science Sanitorium",
  "281P00000X": "Chronic Disease Hospital",
  "281PC2000X": "Chronic Disease Hospital",
  "282N00000X": "General Acute Care Hospital",
  "282NC2000X": "General Acute Care Hospital",
  "282NC0060X": "General Acute Care Hospital",
  "282NR1301X": "General Acute Care Hospital",
  "282NW0100X": "General Acute Care Hospital",
  "282E00000X": "Long Term Care Hospital",
  "286500000X": "Military Hospital",
  "2865C1500X": "Military Hospital",
  "2865M2000X": "Military Hospital",
  "2865X1600X": "Military Hospital",
  "283Q00000X": "Psychiatric Hospital",
  "283X00000X": "Rehabilitation Hospital",
  "283XC2000X": "Rehabilitation Hospital",
  "282J00000X": "Religious Nonmedical Health Care Institution",
  "284300000X": "Special Hospital",
  "291U00000X": "Clinical Medical Laboratory",
  "292200000X": "Dental Laboratory",
  "291900000X": "Military Clinical Medical Laboratory",
  "293D00000X": "Physiological Laboratory",
  "302F00000X": "Exclusive Provider Organization",
  "302R00000X": "Health Maintenance Organization",
  "305S00000X": "Point of Service",
  "305R00000X": "Preferred Provider Organization",
  "311500000X": "Alzheimer Center (Dementia Center)",
  "310400000X": "Assisted Living Facility",
  "3104A0630X": "Assisted Living Facility",
  "3104A0625X": "Assisted Living Facility",
  "317400000X": "Christian Science Facility",
  "311Z00000X": "Custodial Care Facility",
  "311ZA0620X": "Custodial Care Facility",
  "315D00000X": "Hospice, Inpatient",
  "315P00000X": "Intermediate Care Facility, Intellectual Disabilities",
  "310500000X": "Intermediate Care Facility, Mental Illness",
  "313M00000X": "Nursing Facility/Intermediate Care Facility",
  "314000000X": "Skilled Nursing Facility",
  "3140N1450X": "Skilled Nursing Facility",
  "177F00000X": "Lodging",
  "174200000X": "Meals",
  "320800000X": "Community Based Residential Treatment Facility, Mental Illness",
  "320900000X":
    "Community Based Residential Treatment Facility, Intellectual and/or Developmental Disabilities",
  "323P00000X": "Psychiatric Residential Treatment Facility",
  "322D00000X": "Residential Treatment Facility, Emotionally Disturbed Children",
  "320600000X": "Residential Treatment Facility, Intellectual and/or Developmental Disabilities",
  "320700000X": "Residential Treatment Facility, Physical Disabilities",
  "324500000X": "Substance Abuse Rehabilitation Facility",
  "3245S0500X": "Substance Abuse Rehabilitation Facility",
  "385H00000X": "Respite Care",
  "385HR2050X": "Respite Care",
  "385HR2055X": "Respite Care",
  "385HR2060X": "Respite Care",
  "385HR2065X": "Respite Care",
  "331L00000X": "Blood Bank",
  "332100000X": "Department of Veterans Affairs (VA) Pharmacy",
  "332B00000X": "Durable Medical Equipment & Medical Supplies",
  "332BC3200X": "Durable Medical Equipment & Medical Supplies",
  "332BD1200X": "Durable Medical Equipment & Medical Supplies",
  "332BN1400X": "Durable Medical Equipment & Medical Supplies",
  "332BX2000X": "Durable Medical Equipment & Medical Supplies",
  "332BP3500X": "Durable Medical Equipment & Medical Supplies",
  "333300000X": "Emergency Response System Companies",
  "332G00000X": "Eye Bank",
  "332H00000X": "Eyewear Supplier",
  "332S00000X": "Hearing Aid Equipment",
  "332U00000X": "Home Delivered Meals",
  "332800000X": "Indian Health Service/Tribal/Urban Indian Health (I/T/U) Pharmacy",
  "335G00000X": "Medical Foods Supplier",
  "332000000X": "Military/U.S. Coast Guard Pharmacy",
  "332900000X": "Non-Pharmacy Dispensing Site",
  "335U00000X": "Organ Procurement Organization",
  "333600000X": "Pharmacy",
  "3336C0002X": "Pharmacy",
  "3336C0003X": "Pharmacy",
  "3336C0004X": "Pharmacy",
  "3336H0001X": "Pharmacy",
  "3336I0012X": "Pharmacy",
  "3336L0003X": "Pharmacy",
  "3336M0002X": "Pharmacy",
  "3336M0003X": "Pharmacy",
  "3336N0007X": "Pharmacy",
  "3336S0011X": "Pharmacy",
  "335V00000X": "Portable X-ray and/or Other Portable Diagnostic Imaging Supplier",
  "335E00000X": "Prosthetic/Orthotic Supplier",
  "344800000X": "Air Carrier",
  "341600000X": "Ambulance",
  "3416A0800X": "Ambulance",
  "3416L0300X": "Ambulance",
  "3416S0300X": "Ambulance",
  "347B00000X": "Bus",
  "341800000X": "Military/U.S. Coast Guard Transport",
  "3418M1120X": "Military/U.S. Coast Guard Transport",
  "3418M1110X": "Military/U.S. Coast Guard Transport",
  "3418M1130X": "Military/U.S. Coast Guard Transport",
  "343900000X": "Non-emergency Medical Transport (VAN)",
  "347C00000X": "Private Vehicle",
  "343800000X": "Secured Medical Transport (VAN)",
  "344600000X": "Taxi",
  "347D00000X": "Train",
  "347E00000X": "Transportation Broker",
  "342000000X": "Transportation Network Company",
} as const;

/**
 * Organization name keyword mappings for specialty detection
 */
export const ORGANIZATION_SPECIALTY_KEYWORDS = {
  // Cardiology
  cardiology: "Cardiovascular",
  cardiac: "Cardiovascular",
  heart: "Cardiovascular",
  cardiovascular: "Cardiovascular",

  // Pulmonology
  pulmonology: "Pulmonary",
  pulmonary: "Pulmonary",
  lung: "Pulmonary",
  respiratory: "Pulmonary",

  // Oncology
  oncology: "Medical Oncology",
  cancer: "Medical Oncology",
  tumor: "Medical Oncology",
  hematology: "Hematology",

  // Emergency Medicine
  emergency: "Emergency Medicine",
  trauma: "Emergency Medicine",
  urgent: "Emergency Medicine",

  // Surgery
  surgery: "Orthopaedic Surgery",
  surgical: "Orthopaedic Surgery",
  orthopedic: "Orthopaedic Surgery",
  orthopaedic: "Orthopaedic Surgery",
  neurosurgery: "Neurological Surgery",

  // Internal Medicine
  internal: "Internal Medicine",
  medicine: "Internal Medicine",

  // Radiology
  radiology: "Nuclear Medicine",
  imaging: "Nuclear Medicine",

  // Psychiatry
  psychiatry: "Psychiatry",
  mental: "Psychiatry",
  behavioral: "Psychiatry",

  // Family Medicine
  family: "Family Medicine",
  primary: "Family Medicine",

  // Dermatology
  dermatology: "Dermatology",
  skin: "Dermatology",

  // Anesthesiology
  anesthesiology: "Anesthesiology",
  anesthesia: "Anesthesiology",

  // Pathology
  pathology: "Anatomic Pathology & Clinical Pathology",
  laboratory: "Anatomic Pathology & Clinical Pathology",

  // Pediatrics
  pediatrics: "Pediatrics",
  pediatric: "Pediatrics",
  children: "Pediatrics",

  // Obstetrics & Gynecology
  obstetrics: "Obstetrics & Gynecology",
  gynecology: "Obstetrics & Gynecology",
  women: "Obstetrics & Gynecology",

  // Ophthalmology
  ophthalmology: "Ophthalmology",
  eye: "Ophthalmology",
  vision: "Ophthalmology",

  // Otolaryngology
  otolaryngology: "Otolaryngology",
  ear: "Otolaryngology",
  nose: "Otolaryngology",
  throat: "Otolaryngology",

  // Pain Medicine
  pain: "Pain Medicine",

  // Allergy & Immunology
  allergy: "Allergy & Immunology",
  immunology: "Allergy & Immunology",

  // Gastroenterology
  gastroenterology: "Gastroenterology",
  gastro: "Gastroenterology",

  // Nephrology
  nephrology: "Nephrology",
  kidney: "Nephrology",

  // Endocrinology
  endocrinology: "Endocrinology, Diabetes & Metabolism",
  diabetes: "Endocrinology, Diabetes & Metabolism",
  hormone: "Endocrinology, Diabetes & Metabolism",

  // Rheumatology
  rheumatology: "Rheumatology",
  arthritis: "Rheumatology",
  joint: "Rheumatology",

  // Infectious Disease
  infectious: "Infectious Disease",
  infection: "Infectious Disease",
} as const;

/**
 * Extract medical specialty from practitioner qualifications
 */
export function extractSpecialtyFromPractitioners(practitioners: Practitioner[]): string {
  if (!practitioners || practitioners.length === 0) {
    return "Unknown";
  }

  for (const practitioner of practitioners) {
    // Check qualification codes first
    if (practitioner.qualification) {
      for (const qualification of practitioner.qualification) {
        if (qualification.code?.coding) {
          for (const coding of qualification.code.coding) {
            if (
              coding.code &&
              PRACTITIONER_SPECIALTY_CODES[coding.code as keyof typeof PRACTITIONER_SPECIALTY_CODES]
            ) {
              return PRACTITIONER_SPECIALTY_CODES[
                coding.code as keyof typeof PRACTITIONER_SPECIALTY_CODES
              ];
            }
          }
        }

        // Fallback to qualification text
        if (qualification.code?.text) {
          const qualificationText = qualification.code.text.toLowerCase();
          const specialty = findSpecialityKeywordMatch(qualificationText);
          if (specialty) return specialty;
        }
      }
    }
  }

  return "Unknown";
}

/**
 * Extract medical specialty from organization names
 */
export function extractSpecialtyFromOrganizations(organizations: Organization[]): string {
  if (!organizations || organizations.length === 0) {
    return "Unknown";
  }

  for (const organization of organizations) {
    // Check organization type first
    if (organization.type && organization.type.length > 0) {
      for (const type of organization.type) {
        if (!type.text) continue;
        const specialty = findSpecialityKeywordMatch(type.text);
        if (specialty) return specialty;
      }
    }

    // Fallback to organization name
    if (organization.name) {
      const orgName = organization.name.toLowerCase();
      const specialty = findSpecialityKeywordMatch(orgName);
      if (specialty) return specialty;
    }
  }

  return "Unknown";
}

function extractSpecialtyFromLocations(locations: Location[]): string {
  if (!locations || locations.length === 0) {
    return "Unknown";
  }

  for (const location of locations) {
    if (location.type && location.type.length > 0) {
      for (const type of location.type) {
        if (!type.text) continue;
        const specialty = findSpecialityKeywordMatch(type.text);
        if (specialty) return specialty;
      }
    }
  }

  return "Unknown";
}

function findSpecialityKeywordMatch(text: string): string | undefined {
  for (const [keyword, specialty] of Object.entries(ORGANIZATION_SPECIALTY_KEYWORDS)) {
    if (text.includes(keyword)) return specialty;
  }
  return undefined;
}

/**
 * Get specialty for a report with fallback logic
 * Priority: Practitioner specialty > Organization specialty > Location specialty > Unknown
 */
export function getSpecialtyForReport(
  practitioners: Practitioner[],
  organizations?: Organization[],
  locations?: Location[]
): string {
  // First try to extract from practitioners
  const practitionerSpecialty = extractSpecialtyFromPractitioners(practitioners);
  if (practitionerSpecialty !== "Unknown") {
    return practitionerSpecialty;
  }

  // Fallback to organization if available
  if (organizations && organizations.length > 0) {
    const orgSpecialty = extractSpecialtyFromOrganizations(organizations);
    if (orgSpecialty !== "Unknown") {
      return orgSpecialty;
    }
  }

  // Fallback to location if available
  if (locations && locations.length > 0) {
    const locationSpecialty = extractSpecialtyFromLocations(locations);
    if (locationSpecialty !== "Unknown") {
      return locationSpecialty;
    }
  }

  return "-";
}
